<template lang="html">
  <div class="merchant-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.merchant')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.merchantManage')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-row second-tip">
      <div class="title">
          <div class="import-container">
            <el-button v-if="queryFlag" class="verifone-btn upload" type="primary" plain icon="el-icon-upload2" @click="handleImport">{{$t('message.upload')}}</el-button>
            <el-button v-else disabled class="verifone-btn upload" type="primary" plain icon="el-icon-upload2" @click="handleImport">{{$t('message.upload')}}</el-button>
            <input v-show="false" type="file" class="addFileInput" ref="importInput" @change="handleFileInput">
          </div>
      </div>
      <div class="flex-row search-container">
        <div class="select-input-container" style="right:50px" >
        <el-input class="reachInput"
                  :placeholder="$t('message.enterKeyword')"
                  v-model="merchantSearch"  @keyup.enter.native="searchMerchantlist"
                  clearable>
        </el-input>
          <el-select class="rearchSelect" v-model="queryType" :placeholder="$t('message.pleaseChoose')"  >
            <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value" @click.native="getDivision()">
            </el-option>
          </el-select>
        </div>
        <el-button  class="search-btn" icon="el-icon-search" @click="searchMerchantlist"></el-button>

        <div v-if="queryFlag">
            <router-link :to="{path:'/merchantAdde/',query:{id:'newMerchant'}}"><el-button class="verifone-btn" type="primary" plain icon="el-icon-plus">{{$t('message.add')}}</el-button></router-link>
        </div>

        <div v-else>
            <el-button disabled class="verifone-btn" type="primary" plain icon="el-icon-plus">{{$t('message.add')}}</el-button>
        </div>
      </div>
    </div>
    <div class="verifone-panel">
      <div class="appManagement-table-main btn-table">
        <template>
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
            <el-table-column  prop="merchantName"  :label="$t('message.merchantName')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="type" :label="$t('message.type')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="contactName" :label="$t('message.contactName')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="mobilePhone" :label="$t('message.phoneNo')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="email" :label="$t('message.email')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  :label="$t('message.operation')" width="240" align="center" v-if="queryFlag">
              <template slot-scope="scope">
                <router-link :to="{path:'/merchantAdde/',query:{id:scope.row.id}}">
                  <el-button type="success" class="op-btn verifone-btn" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                </router-link>
                <el-button type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('message.operation')" width="240" align="center" v-else>
              <template slot-scope="scope">
                  <router-link :to="{path:'/merchantAdde/',query:{id:scope.row.id}}">
                      <el-button type="success" disabled class="op-btn verifone-btn" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                </router-link>
                <el-button disabled type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange"
                         background layout="prev, pager, next"
                         :current-page="pageNum"
                         :page-count="pageCount">
          </el-pagination>
        </div>
      </div>
    </div>


    <el-dialog title="" :visible.sync="deleteTipVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
        <div class="warn-container flex-row">
            <img class="warn-icon" alt="" src="static/img/alertWarn.png">
            <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
        </div>
        <div class="dialog-body">
            <span>{{$t('message.deleteMerchant')}}</span><span>{{taskName}}</span><span>"?</span>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button class="verifone-btn" type="primary" plain @click="deleteTipVisible = false;">{{$t('message.no')}}</el-button>
            <el-button class="verifone-btn" type="primary" @click="deleteMerchant">{{$t('message.yes')}}</el-button>
        </span>
    </el-dialog>
    <!-- <el-dialog title="Tips" :visible.sync="deleteTipVisible" custom-class="tips-dialog" class="adminAdd-dialog">
      <div class="flex-col tip-content">
        <div><img class="tipImg" src="static/img/tip.png"></div>
        <div class="tipTxt">Are you sure you want to delete App?</div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="deleteTipVisible = false;deleteAppId=''">Cancel</el-button>
                <el-button type="success" @click="deleteMerchant()">OK</el-button>
            </span>
    </el-dialog> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageNum :1,
        pageCount:1,
        deleteMerchantId :'',
        taskName: '',
        merchantSearch:'',
        historySearch: '',
        deleteTipVisible : false,
        deleteSuccess: this.$t('message.deleteSuccess'),
        researchType:0,//0 为查询分页查询APP 1搜索APP
        tableData: [],
        queryFlag: false,
        queryOptions: [ {
          value: 0,
          label: this.$t('message.merchantName')
        },{
          value: 1,
          label: this.$t('message.country')
        },{
          value: 2,
          label: this.$t('message.state')
        },{
          value: 3,
          label: this.$t('message.city')
        },{
          value: 4,
          label: this.$t('message.district')
        },{
          value: 5,
          label: this.$t('message.address')
        },{
          value: 6,
          label: this.$t('message.type')
        }],
        queryType: 0,
        uploadSuccess: this.$t('message.uploadSuccess'),
        xmlCheck: this.$t('message.xmlCheck'),
      }
    },
    mounted() {
      this.queryMerchantList();
      this.setQuery();
    },
    methods: {
      getDivision(){
        this.merchantSearch='';
      },
        setQuery() {
            let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
            this.queryFlag = !roleArr.includes(11);
        },
      handleCurrentChange(val) {
        console.log("val"+val);
        this.pageNum = val;
        if(this.researchType == 0) {
          this.queryMerchantList();
        }
        else if(this.researchType == 1) {
          this.searchMerchantlist();
        }
      },
      queryMerchantList() {
        let that = this,
            obj = {
              pageNum:this.pageNum
            };

        this.$axios({
            method: 'post',
            url: '/marketplace/merchant/page',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.researchType = 0;
            //this.$refs.codeImg.src = response.data.image;
            that.pageCount = response.data.totalPage;
            that.tableData= response.data.merchantList;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      searchMerchantlist() {
        let that = this,
            obj = {
              queryType:this.queryType,
              queryInfo:this.merchantSearch,
              pageNum:this.pageNum
            };

        if(this.merchantSearch == '') {
            this.pageNum = 1;
            this.historySearch = '';
            this.queryMerchantList();
            return;
        }

        //new query => refresh page
        if(this.merchantSearch != this.historySearch) {
            this.pageNum = 1;
        }else {
            obj.pageNum = this.pageNum;
        }

        this.$axios({
            method: 'post',
            url: '/marketplace/merchant/search',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.researchType = 1;
            that.tableData = response.data.merchantList;
            that.pageCount = response.data.totalPage;
            that.historySearch = that.merchantSearch;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      showDeleteDialog(row) {
        this.deleteTipVisible = true;
        this.deleteMerchantId = row.id;
        this.taskName = row.merchantName;
        console.log(row);
        console.log(row.date,row.name,row.id);
      },
      deleteMerchant () {
        let that = this,
            obj = {
              id:this.deleteMerchantId
            };

        this.$axios({
            method: 'post',
            url: '/marketplace/merchant/delete',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.deleteMerchantId = '';
            that.deleteTipVisible = false;
            that.$message({
              type: "success",
              message: this.deleteSuccess,
              duration:'3000',
            });
            if(that.researchType == 0) {
              that.queryMerchantList();
            }
            else if(that.researchType == 1) {
              this.searchMerchantlist();
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      handleImport() {
        this.$refs.importInput.click();
      },
      handleFileInput(e) {
        let files = e.target.files[0];
        let length = files.name.split('.').length;
        let fileSuffix = files.name.split('.')[length - 1];
        let reader = new FileReader();
        let that = this;

        console.log(fileSuffix);

        reader.readAsDataURL(files);
        reader.onload = function(e) {
          let mb = (e.total/1024)/1024;

          if(fileSuffix != 'xml' && fileSuffix != 'XML') {
            console.log('err');
            that.$message({
              type: "error",
              message: that.xmlCheck,
              duration:'3000',
            });

            return;
          }

          that.submitFile(this.result, fileSuffix);
        }
      },
      submitFile(file, filePrefix) {
        let that = this,
          obj = {
            file: file,
            filePrefix: filePrefix
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/merchant/import',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {

            that.$message({
              type: "success",
              message: that.uploadSuccess,
              duration:'3000',
            });

            that.pageNum = 1;
            that.queryMerchantList();//?查询需确定
          }
        }).catch((err) => {
          console.log(err);
        });

        this.$refs.importInput.value = null;
      },
    }
  }
</script>

<style lang="css" scoped="scope">

  .select-input-container{
    border: #8c939d;
  }
  .appManagement-container {
    /*background-color: #E0EAF4;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
  }
  .appManagement-table {
    width:100%;
    padding:10px 30px;
  }
  .appManagement-table-main {
    padding: 20px;
    background-color: #fff;
  }
  .pagination-main {
    padding:30px 0 10px;
    background: #fff;
    width: 100%;
  }
  .appManagement-search .el-input__inner {
    border-radius: 20px;
  }
 .reachInput {
    position: relative;
   /* border-right:none!important;*/
    left: 40px;
  }
  .search-btn {
    margin-right: 30px;
  }
  .rearchSelect {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/Merchantlist.vue